type HabitatRef = string | { _id?: string; habitatId?: string } | null | undefined;

/**
 * The habitat a media item belongs to, whichever shape the endpoint sent it in: an id, the populated
 * habitat, or the album's habitat summary.
 *
 * Permission checks on a media item ask about this habitat, never the one in view — My Album and
 * the share modal show media from many habitats at once.
 */
const habitatIdOfMedia = (media: { habitatId?: HabitatRef; habitat?: HabitatRef } | null | undefined) => {
  const ref = media?.habitatId ?? media?.habitat;
  if (!ref) return undefined;
  if (typeof ref === 'string') return ref;
  return ref._id ?? ref.habitatId;
};

export default habitatIdOfMedia;
